import { Injectable } from '@angular/core';
import { TerminalModal } from 'src/app/pages/common/system/terminal/model/terminal.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class DailySalesService {

  
     constructor(private http: HttpClient) { }
    
      getDailyList(requestData:RequestData): Observable<any> {
        return this.http.post(environment.baseUrl+'/shop/reports/get-daily-sales', requestData);
    
      }

      downloadExcel(requestData: any): Observable<Blob> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
       // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
    
        return this.http.post(environment.baseUrl + '/shop/reports/export-daily-sales', requestData, { headers, responseType: 'blob' })
          .pipe(
            //catchError(this.handleError)
          );
    
      }
    
      recalculate(requestData:any): Observable<any> {
        return this.http.post(environment.baseUrl+'/shop/reports/daily-sales-recalculate', requestData);
    
      }
}
